module.exports = __webpack_public_path__ + "img/sd.8aa90142.svg";